<template>
    <vx-modal v-model:visible="visible" size="md" padding="standard">
        <template v-slot:header> Imported Files </template>
        <template v-slot:subheader>
            {{ props.run?.imported_files.length || 0 }} file(s) imported from this run
        </template>

        <div v-if="props.run" class="space-y-2">
            <div
                v-for="(file, index) in props.run.imported_files"
                :key="index"
                class="p-3 bg-slate-50 rounded border border-slate-200"
                data-test="file-item"
            >
                <div class="font-mono text-sm break-all">{{ file }}</div>
            </div>
        </div>
    </vx-modal>
</template>

<script lang="ts" setup>
import { VxModal } from '@voxie/frontend-components';
import type { FtpPullRun } from '~/types/ftp-pull.types';

interface Props {
    run: FtpPullRun | null;
}

const props = defineProps<Props>();

const visible = defineModel<boolean>('visible', {
    default: false,
});
</script>
